import { createSlice } from '@reduxjs/toolkit';
import {
  baseRequestState,
  setFetchingError,
  setFetchingRequest,
  setFetchingSuccess,
} from '../helpers';
import { fetchCurrentGuestData } from './asyncThunk';
import { APSetUser, ICurrentGuestState } from './types';

const initialState: ICurrentGuestState = {
  guest: null,
  requests: {
    getGuestData: {
      ...baseRequestState,
    },
  },
};

const currentGuestSlice = createSlice({
  name: 'currentGuest',
  initialState,
  reducers: {
    setCurrentGuest(state, action: APSetUser) {
      state.guest = action.payload;
    },
    resetCurrentGuestState(state) {
      state.guest = null;
      state.requests.getGuestData = { ...baseRequestState };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCurrentGuestData.pending, (state) => {
      setFetchingRequest(state.requests.getGuestData);
    });

    builder.addCase(fetchCurrentGuestData.fulfilled, (state, action) => {
      setFetchingSuccess(state.requests.getGuestData);
      state.guest = action.payload;
    });

    builder.addCase(fetchCurrentGuestData.rejected, (state, action) => {
      setFetchingError(state.requests.getGuestData, action.payload);
    });
  },
});

export const { setCurrentGuest, resetCurrentGuestState } =
  currentGuestSlice.actions;
export const currentGuestReducer = currentGuestSlice.reducer;
